import HttpRequest from './HttpRequest';

export default class ImageService extends HttpRequest {
  static endpoint = 'images';

  static async getAll() {
    this.endpoint = 'images';
    const response = await this.get();
    return response;
  }

  static async getById(id) {
    this.endpoint = 'images';
    const response = await this.get(id);
    return response;
  }

  static async create(data) {
    this.endpoint = 'images';
    const response = await this.post(data);
    return response;
  }

  static async update(id, data) {
    this.endpoint = 'images';
    const response = await this.put(id, data);
    return response;
  }

  static async remove(id) {
    this.endpoint = 'images';
    const response = await this.delete(id);
    return response;
  }

  static async uploadImage(data) {
    this.endpoint = 'images/create-image';
    const response = await this.post(data);
    return response;
  }

  static async deleteImage(data) {
    this.endpoint = 'images/delete-image';
    const response = await this.delete(data);
    return response;
  }
}
